<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Update product</div>
            <fieldset class="border p-2">
              <div>
                <form @submit.prevent="updateProduct()">
                  <div class="row">
                    <div class="col-md-6">
                      <input type="hidden" class="id" :value="Product.id" />
                      <div class="form-group">
                        <label>Product name</label>
                        <input
                          type="text"
                          class="form-control product_name input_rounded"
                          :value="Product.product_name"
                          placeholder="product name"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Product measurement</label>
                        <select
                          name="product_measurement"
                          class="form-control input_rounded product_measurement"
                          :value="Product.product_measurement"
                        >
                          <option value>Select Measurement</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="PCS">PIECES</option>
                          <option value="LTS">LITRES</option>
                          <option value="SET">SET</option>
                          <option value="PAIR">PAIR</option>
                          <option value="MTR">METRES</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Product description</label>
                        <textarea
                          class="form-control product_description input_rounded"
                          :value="Product.product_description"
                          placeholder="product description"
                          required
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label>Minimum Stock level </label>
                        <input
                          type="number"
                          class="form-control minimum_stock_level"
                          :value="Product.minimum_stock_level"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat btn-rounded updatingProduct"
                  >
                    <i class="fa fa-plus"></i> update product
                  </button>
                  <button
                    type="button"
                    class="btn btn-info btn-flat btn-rounded updatingProductLoader"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Product.length === 0) {
      router.push("/manageproducts");
    }
  },
  computed: {
    ...mapGetters(["Product"]),
  },
  methods: {
    ...mapActions(["updateProduct"]),
  },
};
</script>
<style scoped>
.updatingProductLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/products/updateproduct.vue